import { registerPlugin } from "../common/mapstore/registerPlugin";

import React from "react";

import { connect } from "react-redux";
import layersReducer from "./reducer/layersReducer";
import layersEpic from "./epic/layersEpic";
import groupParamsEpic from "./epic/groupParamsEpic";
import sortLayersEpic from "./epic/sortLayersEpic";

class LayerProperties extends React.Component {
    render() {
        return null;
    }
}

export const ConnectedLayerProperties = connect()(LayerProperties);

export const LayerPropertiesPlugin = {
    name: "LayerPropertiesPlugin",
    config: {
        component: ConnectedLayerProperties,
        reducers: { layerOptions: layersReducer },
        epics: {
            layersEpic: layersEpic,
            groupParamsEpic: groupParamsEpic,
            sortLayersEpic: sortLayersEpic,
        },
    },
};

export const register = () => registerPlugin(LayerPropertiesPlugin);
